<template>
  <div>
    <el-form
      ref="ruleForm"
      :model="form"
      :rules="rules"
      label-width="80px"
      label-position="left"
    >
      <el-form-item label="题目分类" prop="dirId">
        <el-select
          style="width: 100%"
          v-model="form.dirId"
          placeholder="请选择"
        >
          <el-option
            v-for="item in dirList"
            :key="item.id"
            :label="item.dirName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="题目" prop="questionName">
        <el-input v-model="form.questionName" />
      </el-form-item>
      <el-form-item label="分值" prop="score">
        <el-input v-model="form.score" />
      </el-form-item>
      <el-form-item
        v-if="questionType === 1 || questionType === 2"
        label="选项A"
        prop="questionName"
      >
        <div class="se-flex se-cur">
          <el-input style="width: 70%" v-model="form.optionsA" />
          <!-- 单选 -->
          <div
            v-if="questionType === 1"
            class="se-flex aic"
            style="margin-left: 40px; width: 20%"
            @click="choice(0)"
          >
            <div :class="['se-circle', index === 0 ? 'se-bor-sel' : 'se-bor']">
              <div :class="['se-dot', index === 0 ? 'se-bgc' : '']"></div>
            </div>
            <div>正确答案</div>
          </div>
          <!-- 多选 -->
          <div style="margin-left: 20px">
            <el-checkbox
              v-if="questionType === 2"
              :checked="checkedList[0].checked"
              @change="onChange($event, 0)"
              >正确答案</el-checkbox
            >
          </div>
        </div>
      </el-form-item>
      <el-form-item
        v-if="questionType === 1 || questionType === 2"
        label="选项B"
        prop="optionsB"
      >
        <div class="se-flex se-cur">
          <el-input style="width: 70%" v-model="form.optionsB" />
          <!-- 单选 -->
          <div
            v-if="questionType === 1"
            class="se-flex aic"
            style="margin-left: 40px; width: 20%"
            @click="choice(1)"
          >
            <div :class="['se-circle', index === 1 ? 'se-bor-sel' : 'se-bor']">
              <div :class="['se-dot', index === 1 ? 'se-bgc' : '']"></div>
            </div>
            <div>正确答案</div>
          </div>
          <!-- 多选 -->
          <div style="margin-left: 20px">
            <el-checkbox
              v-if="questionType === 2"
              :checked="checkedList[1].checked"
              @change="onChange($event, 1)"
              >正确答案</el-checkbox
            >
          </div>
        </div>
      </el-form-item>
      <el-form-item
        v-if="questionType === 1 || questionType === 2"
        label="选项C"
        prop="optionsC"
      >
        <div class="se-flex se-cur">
          <el-input style="width: 70%" v-model="form.optionsC" />
          <!-- 单选 -->
          <div
            v-if="questionType === 1"
            class="se-flex aic"
            style="margin-left: 40px; width: 20%"
            @click="choice(2)"
          >
            <div :class="['se-circle', index === 2 ? 'se-bor-sel' : 'se-bor']">
              <div :class="['se-dot', index === 2 ? 'se-bgc' : '']"></div>
            </div>
            <div>正确答案</div>
          </div>
          <!-- 多选 -->
          <div style="margin-left: 20px">
            <el-checkbox
              v-if="questionType === 2"
              :checked="checkedList[1].checked"
              @change="onChange($event, 2)"
              >正确答案</el-checkbox
            >
          </div>
        </div>
      </el-form-item>
      <el-form-item
        v-if="questionType === 1 || questionType === 2"
        label="选项D"
        prop="optionsD"
      >
        <div class="se-flex se-cur">
          <el-input style="width: 70%" v-model="form.optionsD" />
          <!-- 单选 -->
          <div
            v-if="questionType === 1"
            class="se-flex aic"
            style="margin-left: 40px; width: 20%"
            @click="choice(3)"
          >
            <div :class="['se-circle', index === 3 ? 'se-bor-sel' : 'se-bor']">
              <div :class="['se-dot', index === 3 ? 'se-bgc' : '']"></div>
            </div>
            <div>正确答案</div>
          </div>
          <!-- 多选 -->
          <div style="margin-left: 20px">
            <el-checkbox
              v-if="questionType === 2"
              :checked="checkedList[1].checked"
              @change="onChange($event, 3)"
              >正确答案</el-checkbox
            >
          </div>
        </div>
      </el-form-item>
      <!-- 填空 -->
      <el-form-item v-if="questionType === 3" label="答案">
        <div class="se-ft">
          若一个空有多个正确答案，每个答案间用英文分号分隔，学员答案匹配任意一个都算正确
        </div>
      </el-form-item>
      <template v-if="questionType === 3">
        <el-form-item
          v-for="(domain, i) in form.domains"
          :key="domain.questionType"
          :label="`填空${i + 1}`"
          :prop="'domains.' + i + '.value'"
          :rules="{
            required: true,
            message: '请填写',
            trigger: 'blur',
          }"
        >
          <el-input
            v-model="domain.value"
            placeholder="请填写"
            style="width: 70%; margin-right: 8px"
          />
          <i
            style="font-size: 20px"
            v-if="form.domains.length > 1"
            :disabled="form.domains.length === 1"
            class="el-icon-remove-outline"
            @click="removeDomain(domain)"
          ></i>
        </el-form-item>
        <el-form-item v-if="questionType === 3 && form.domains.length < 4">
          <el-button
            type="danger"
            size="large"
            style="width: 200px"
            icon="el-icon-circle-plus-outline"
            @click="addDomain"
          >
            添加填空
          </el-button>
        </el-form-item>
        <!-- <el-form-item label="解析" prop="questionName">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4 }"
            placeholder="请输入"
            v-model="form.analysis"
          >
          </el-input>
        </el-form-item> -->
      </template>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
    questionType: {
      type: Number,
      default: null,
    },
    trainCourseId: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      form: {
        value: "",
        domains: [],
        id: null,
        questionName: "",
        score: null,
        optionsA: "",
        optionsB: "",
        optionsC: "",
        optionsD: "",
        trainCourseQuestionOptions: [
          {
            isRight: 0,
            questionOption: "",
            sortNum: 1,
          },
          {
            isRight: 0,
            questionOption: "",
            sortNum: 2,
          },
          {
            isRight: 0,
            questionOption: "",
            sortNum: 3,
          },
          {
            isRight: 0,
            questionOption: "",
            sortNum: 4,
          },
        ],
        analysis: "",
        questionType: 0,
        dirId: null,
      },
      rules: {
        questionName: [{ required: true, message: "请填写", trigger: "blur" }],
        score: [{ required: true, message: "请填写", trigger: "blur" }],
        optionsA: [{ required: true, message: "请填写", trigger: "blur" }],
        optionsB: [{ required: true, message: "请填写", trigger: "blur" }],
        optionsC: [{ required: true, message: "请填写", trigger: "blur" }],
        optionsD: [{ required: true, message: "请填写", trigger: "blur" }],
        dirId: [{ required: true, message: "请选择", trigger: "blur" }],
      },
      dirList: [],
      index: null,
      checkedList: [
        { checked: false },
        { checked: false },
        { checked: false },
        { checked: false },
      ],
    };
  },

  created() {
    this.getTestDirList();
  },

  methods: {
    //   获取分类
    async getTestDirList() {
      const res = await this.$http.get("/server/api/dir/list");
      this.dirList = res.rows;
    },

    // 单选
    choice(value) {
      this.index = value;
      // console.log(this.index)
      this.form.trainCourseQuestionOptions.forEach((v) => {
        v.isRight = 0;
      });
      this.form.trainCourseQuestionOptions[value].isRight = 1;
      // console.log(this.form)
    },

    // 多选
    onChange(e, value) {
      console.log(e);
      console.log(value);
      this.form.trainCourseQuestionOptions[value].isRight = Number(e);
      this.checkedList[value].checked = e;
    },

    addDomain() {
      this.form.domains.push({
        value: "",
        key: Date.now(),
      });
    },

    removeDomain(item) {
      const index = this.form.domains.indexOf(item);
      if (index !== -1) {
        this.form.domains.splice(index, 1);
      }
    },

    // 确认
    confirm() {
      this.$set(
        this.form.trainCourseQuestionOptions[0],
        "questionOption",
        this.form.optionsA
      );
      this.$set(
        this.form.trainCourseQuestionOptions[1],
        "questionOption",
        this.form.optionsB
      );
      this.$set(
        this.form.trainCourseQuestionOptions[2],
        "questionOption",
        this.form.optionsC
      );
      this.$set(
        this.form.trainCourseQuestionOptions[3],
        "questionOption",
        this.form.optionsD
      );
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          if (this.index === null && this.questionType === 1)
            return this.$message.error("请选择正确答案");
          if (this.questionType === 2) {
            const isChecked = this.checkedList.some((v) => {
              return v.checked === true;
            });
            if (!isChecked) return this.$message.error("请选择正确答案");
          }
          if (this.questionType === 3) {
            this.form.trainCourseQuestionOptions.forEach((v) => {
              v.isRight = 1;
            });
            this.form.trainCourseQuestionOptions.length =
              this.form.domains.length;
            for (var j = 0; j <= this.form.domains.length - 1; j++) {
              this.form.trainCourseQuestionOptions[j].questionOption =
                this.form.domains[j].value;
            }
          }
          const data = {
            courseBelong: 1,
            trainCourseId: this.trainCourseId,
            dirId: this.form.dirId,
            trainCourseQuestionList: [
              {
                ...this.form,
                questionType: this.questionType,
                courseBelong: 1,
                analysis: this.form.analysis,
              },
            ],
          };
          await this.$http.post(
            "/server/api/coursequestion/batchAddTrainCourseQuestion",
            data
          );
          this.$emit("update");
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.se-cur {
  cursor: pointer;
}

.se-bor-sel {
  border: 1px solid #f56c6c;
}

.se-bor {
  border: 1px solid #ccc;
}

.se-circle {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  .se-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }
}

.se-bgc {
  background-color: #f56c6c;
}

.se-ft {
  color: #00000072;
  font-size: 13px;
}
</style>
